import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import PERIODICIDADE from "../../data/Periodicidade";
import WS from '../../config/Ws';
import PAGES from '../../config/Pages';
import Requisitions from '../../utils/requisitions/Requisitions';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import Alert from "../../components/alert/Alert";

const URL_SAVE = WS.perguntas.save;


class Page extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      [props.name]:props.value,
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE],
      text: '' ,
      editor: null,
      detalhe: props.detalhe
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeEditor = this.handleChangeEditor.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleChangeEditor(value) {
    this.setState({ resposta: value });
  }

  handleSubmit (e){
    const formData = new FormData(e.target);
    const pergunta = formData.get('pergunta');
    const resposta = formData.get('resposta');

    let modal = new Alert();
    var _self = this;
    const { salvoSucesso, preenchaTodosCampos } = this.state.strings;

    var object = FormDataToJson(formData);

    const {
      atencao,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    if(pergunta !== '' && resposta != ''){
      Requisitions({
        url:URL_SAVE,
        data: object,
        sucess:function(data){
          var msg;
          _self.props.modal.close();
          _self.props.history.push(PAGES.planos);
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }else{
      let msg = {
        title: atencao,
        text:preenchaTodosCampos
      };
      Dialog.create(msg);
    }

    e.preventDefault();
  }

  render (){
    const
    {
      txtPergunta,
      txtResposta,
      digiteAqui,
      salvar,
      cadastroPergunta
    } = this.state.strings;
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} /> : '';
    const pergunta = this.props.detalhe ? this.props.detalhe.nome : '';
    const resposta = this.props.detalhe ? this.props.detalhe.resposta : '';

    return (
      <div>
        <MainTitle title={cadastroPergunta}></MainTitle>
          <form className="" onSubmit={this.handleSubmit}>
            {id}
          <div>
            <TextInput value={pergunta} name="pergunta" title={txtPergunta} placeholder={digiteAqui}></TextInput>
          </div>
          <div className="">
          <TextArea value={resposta} name="resposta" title={txtResposta} placeholder=""></TextArea>
          </div>
          <br /><br />
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/perguntas-frequentes/Page.js